function importAll(r) {
  return r.keys().map(r);
}

const Header_H = importAll(require.context('../assets/photos/Header_H', false, /\.(png|jpe?g|svg)$/));

export default Header_H;